import TickmarkHolder from './TickmarkHolder'

export default TickmarkHolder
